import Logo from "../Logo";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-white/5 bg-black/60 backdrop-blur"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid gap-10 lg:grid-cols-3">
          <div>
            <Logo />
            <p className="mt-4 text-sm text-zinc-500 max-w-xs leading-relaxed">
              Montage de PC gaming sur mesure à Paris. Devis gratuit, prix
              garanti, livraison soignée.
            </p>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-zinc-500">
              Navigation
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <a href="#services" className="text-zinc-300 hover:text-violet-300">
                  Services
                </a>
              </li>
              <li>
                <a href="#pricing" className="text-zinc-300 hover:text-violet-300">
                  Tarifs
                </a>
              </li>
              <li>
                <a href="#portfolio" className="text-zinc-300 hover:text-violet-300">
                  Réalisations
                </a>
              </li>
              <li>
                <a href="#faq" className="text-zinc-300 hover:text-violet-300">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#contact" className="text-zinc-300 hover:text-violet-300">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-zinc-500">
              Contact
            </p>
            <p className="mt-4 text-sm text-zinc-400 leading-relaxed">
              industrieszf@gmail.com
              <br />
              07 80 50 32 32
              <br />
              13 Rue Paul Demange, 92360 Meudon
            </p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-wrap items-center justify-between gap-4">
          <p className="text-xs text-zinc-500">
            © {new Date().getFullYear()} ZFIndustries. Tous droits réservés.
          </p>
          <div className="flex items-center gap-5 text-xs text-zinc-500">
            <span>Mentions légales</span>
            <span>·</span>
            <span>CGV</span>
            <span>·</span>
            <a
              href="/admin"
              data-testid="footer-admin-link"
              className="hover:text-violet-300"
            >
              Admin
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
